import React from "react";
import { Link } from "react-router-dom";

const NoAccess: React.FC = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8f9fa",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <h1 style={{ fontSize: "60px", fontWeight: 700, color: "#dc3545" }}>
        403
      </h1>
      <h2 style={{ fontSize: "24px", fontWeight: 600, marginBottom: "10px" }}>
        Access Denied
      </h2>
      <p style={{ fontSize: "16px", color: "#6c757d" }}>
        You do not have permission to view this page.
      </p>

      <Link
        to="/"
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          background: "#0d6efd",
          color: "#fff",
          borderRadius: "6px",
          textDecoration: "none",
        }}
      >
        Go Back to Login
      </Link>
    </div>
  );
};

export default NoAccess;
